module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('entity-page', {
    attrs: {
      "id": "page__lathing",
      "loading": _vm.progress
    }
  }, [_c('template', {
    slot: "header-right"
  }, [_c('z-icon-button', {
    attrs: {
      "icon": ['fa', 'xmark'],
      "danger-light": "",
      "rounded": ""
    },
    on: {
      "click": _vm.back
    }
  }), _vm._v(" "), _c('z-icon-button', {
    attrs: {
      "icon": ['fa', 'check'],
      "success-light": "",
      "rounded": ""
    },
    on: {
      "click": _vm.save
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('z-input-autocomplete', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "col-6",
    attrs: {
      "id": "city__id",
      "name": "city_id",
      "property": "id",
      "return": "id",
      "label": "Населённый пункт (город/посёлок/село/...)",
      "display-property": "label",
      "callback": _vm.getCities,
      "default": (_vm.price.city && _vm.price.city.name) ? _vm.price.city.name : '',
      "error": _vm.errors.first('city_id'),
      "data-vv-name": "city_id",
      "data-vv-as": ' '
    },
    on: {
      "select": _vm.selectCity
    },
    model: {
      value: (_vm.price.city_id),
      callback: function($$v) {
        _vm.$set(_vm.price, "city_id", $$v)
      },
      expression: "price.city_id"
    }
  }), _vm._v(" "), _c('z-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        'required': true,
        min_value: 0.01,
        max_value: 9999999999,
        decimal: [2, '.']
      }),
      expression: "{'required': true, min_value: 0.01, max_value: 9999999999, decimal: [2, '.']}"
    }],
    staticClass: "col-6",
    attrs: {
      "label": "Стоимость обрешётки за 1м<sup>3<sup>",
      "name": "price",
      "id": "price",
      "required": true,
      "error": _vm.errors.first('price'),
      "type": "number",
      "data-vv-name": "price",
      "data-vv-as": ' '
    },
    model: {
      value: (_vm.price.price),
      callback: function($$v) {
        _vm.$set(_vm.price, "price", $$v)
      },
      expression: "price.price"
    }
  }), _vm._v(" "), _c('z-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        'required': true,
        min_value: 0.001,
        max_value: 9999999999,
        decimal: [3, '.']
      }),
      expression: "{'required': true, min_value: 0.001, max_value: 9999999999, decimal: [3, '.']}"
    }],
    staticClass: "col-6",
    attrs: {
      "label": "Минимальный объём",
      "name": "volume_min",
      "id": "volume_min",
      "required": true,
      "error": _vm.errors.first('volume_min'),
      "type": "number",
      "data-vv-name": "volume_min",
      "data-vv-as": ' '
    },
    model: {
      value: (_vm.price.volume_min),
      callback: function($$v) {
        _vm.$set(_vm.price, "volume_min", $$v)
      },
      expression: "price.volume_min"
    }
  }), _vm._v(" "), _c('z-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        'required': true,
        min_value: 0.01,
        max_value: 9999999999,
        decimal: [2, '.']
      }),
      expression: "{'required': true, min_value: 0.01, max_value: 9999999999, decimal: [2, '.']}"
    }],
    staticClass: "col-6",
    attrs: {
      "label": "Стоимость за минимальный объём",
      "name": "price_min",
      "id": "price_min",
      "required": true,
      "error": _vm.errors.first('price_min'),
      "type": "number",
      "data-vv-name": "price_min",
      "data-vv-as": ' '
    },
    model: {
      value: (_vm.price.price_min),
      callback: function($$v) {
        _vm.$set(_vm.price, "price_min", $$v)
      },
      expression: "price.price_min"
    }
  })], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d9acb028","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/cost/views/DoomPrice.vue
// module id = 1264
// module chunks = 0